import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SpinnerLoader from '../spinnerloader';

class PageLoader extends React.PureComponent {
  render() {
    const { page_loading, page_loading_text } = this.props;
    if (page_loading)
      return (
        <div className="ori-absolute ori-bg-black-light ori-align-full ori-zindex-99999">
          <SpinnerLoader text={page_loading_text} bg_white />
        </div>
      );
    return null;
  }
}

const mapStateToProps = state => {
  return {
    page_loading: state.page_details.loaders.page_loading,
    page_loading_text: state.page_details.loaders.page_loading_text,
  };
};

PageLoader.propTypes = {
  page_loading: PropTypes.bool,
  page_loading_text: PropTypes.string,
};

export default connect(mapStateToProps)(PageLoader);



// WEBPACK FOOTER //
// ./src/components/pageloader/index.js